<span class="warning-badge"
      *ngIf="warningBadgeValue | async as value">
    {{value}}
</span>
